export const formatCurrency = amount => {
  const currencyFormatter = new Intl.NumberFormat("en-us", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })
  const isIE11 = !!window.MSInputMethodContext && !!document.documentMode
  if (isIE11 && amount < 0) {
    return `-${currencyFormatter.format(Math.abs(amount) || 0)}`
  }
  return currencyFormatter.format(amount || 0)
}

export function abbreviate(n, d) {
  if (n < 1000) {
    return "$" + n.toFixed(0).replace(/[.]$/, "")
  } else if (n < 1000000) {
    return (
      "$" +
      (n / 1000)
        .toFixed(2)
        .replace(/[0]+$/, "")
        .replace(/[.]$/, "") +
      "k"
    )
  } else {
    return (
      "$" +
      (n / 1000000)
        .toFixed(2)
        .replace(/[0]+$/, "")
        .replace(/[.]$/, "") +
      "M"
    )
  }
}

// http://stackoverflow.com/a/3177838
export const calculateTimeSince = ISODateString => {
  var date = new Date(ISODateString)
  var seconds = Math.floor((new Date() - date) / 1000)

  var interval = Math.floor(seconds / 31536000)

  if (interval > 1) {
    return interval + " years"
  }
  interval = Math.floor(seconds / 2592000)
  if (interval > 1) {
    return interval + " months"
  }
  interval = Math.floor(seconds / 86400)
  if (interval > 1) {
    return interval + " days"
  }
  interval = Math.floor(seconds / 3600)
  if (interval > 1) {
    return interval + " hours"
  }
  interval = Math.floor(seconds / 60)
  if (interval > 1) {
    return interval + " minutes"
  }
  return Math.floor(seconds) + " seconds"
}

export const stateOptions = [
  { value: "AL", text: "Alabama" },
  { value: "AK", text: "Alaska" },
  { value: "AZ", text: "Arizona" },
  { value: "AR", text: "Arkansas" },
  { value: "CA", text: "California" },
  { value: "CO", text: "Colorado" },
  { value: "CT", text: "Connecticut" },
  { value: "DE", text: "Delaware" },
  { value: "DC", text: "District Of Columbia" },
  { value: "FL", text: "Florida" },
  { value: "GA", text: "Georgia" },
  { value: "HI", text: "Hawaii" },
  { value: "ID", text: "Idaho" },
  { value: "IL", text: "Illinois" },
  { value: "IN", text: "Indiana" },
  { value: "IA", text: "Iowa" },
  { value: "KS", text: "Kansas" },
  { value: "KY", text: "Kentucky" },
  { value: "LA", text: "Louisiana" },
  { value: "ME", text: "Maine" },
  { value: "MD", text: "Maryland" },
  { value: "MA", text: "Massachusetts" },
  { value: "MI", text: "Michigan" },
  { value: "MN", text: "Minnesota" },
  { value: "MS", text: "Mississippi" },
  { value: "MO", text: "Missouri" },
  { value: "MT", text: "Montana" },
  { value: "NE", text: "Nebraska" },
  { value: "NV", text: "Nevada" },
  { value: "NH", text: "New Hampshire" },
  { value: "NJ", text: "New Jersey" },
  { value: "NM", text: "New Mexico" },
  { value: "NY", text: "New York" },
  { value: "NC", text: "North Carolina" },
  { value: "ND", text: "North Dakota" },
  { value: "OH", text: "Ohio" },
  { value: "OK", text: "Oklahoma" },
  { value: "OR", text: "Oregon" },
  { value: "PA", text: "Pennsylvania" },
  { value: "RI", text: "Rhode Island" },
  { value: "SC", text: "South Carolina" },
  { value: "SD", text: "South Dakota" },
  { value: "TN", text: "Tennessee" },
  { value: "TX", text: "Texas" },
  { value: "UT", text: "Utah" },
  { value: "VT", text: "Vermont" },
  { value: "VA", text: "Virginia" },
  { value: "WA", text: "Washington" },
  { value: "WV", text: "West Virginia" },
  { value: "WI", text: "Wisconsin" },
  { value: "WY", text: "Wyoming" }
]

export const emailValidator = value =>
  /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i.test(
    value
  )

export function getAge(birth_date, asOfDate) {
  const birthDate = new Date(birth_date)
  if (!asOfDate) {
    asOfDate = new Date()
  }
  let age = 0
  if (
    birthDate.getMonth() > asOfDate.getMonth() ||
    (birthDate.getMonth() === asOfDate.getMonth() &&
      birthDate.getDate() > asOfDate.getDate())
  ) {
    age = asOfDate.getFullYear() - birthDate.getFullYear() - 1
  } else {
    age = asOfDate.getFullYear() - birthDate.getFullYear()
  }
  if (age === 0) {
    if (birthDate.getDate() > asOfDate.getDate()) {
      age = asOfDate.getMonth() - birthDate.getMonth() - 1
    } else {
      age = Math.floor(
        (asOfDate.getTime() - birthDate.getTime()) / (1000 * 3600 * 24 * 30)
      )
    }
    return age + (age === 1 ? " month" : " months")
  }
  return age
}

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
]

export function formatDate(date, showYear = true) {
  const dateUTC =
    typeof date === "string" || date instanceof String ? new Date(date) : date
  const todayUTC = new Date()
  if (dateUTC.getUTCFullYear() !== todayUTC.getUTCFullYear()) {
    return `${
      MONTHS[dateUTC.getUTCMonth()]
    } ${dateUTC.getUTCDate()}, ${dateUTC.getUTCFullYear()}`
  } else {
    return `${MONTHS[dateUTC.getUTCMonth()]} ${dateUTC.getUTCDate()}`
  }
}

export function formatDateToLocale(date) {
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    day: "numeric",
    month: "short",
    timeZone: "UTC"
  })
}

export function daysBetweenDates(date1, date2) {
  const timeDifference = date2.getTime() - date1.getTime()
  return timeDifference / (1000 * 60 * 60 * 24) + 1
}
